import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { queryKeys } from "../query-keys.js";
export function useRenameAskThread() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, title }) => getNookClient().renameAskThread(id, title),
        async onMutate({ id, title }) {
            await queryClient.cancelQueries({ queryKey: queryKeys.ask.threads() });
            const snapshot = queryClient.getQueryData(queryKeys.ask.threads());
            const thread = queryClient.getQueryData(queryKeys.ask.thread(id));
            queryClient.setQueryData(queryKeys.ask.threads(), (current) => current && {
                ...current,
                pages: current.pages.map((page) => ({
                    ...page,
                    items: page.items.map((item) => (item.id === id ? { ...item, title } : item)),
                })),
            });
            queryClient.setQueryData(queryKeys.ask.thread(id), (current) => current && { ...current, title });
            return { snapshot, thread };
        },
        onError(_error, { id }, context) {
            queryClient.setQueryData(queryKeys.ask.threads(), context?.snapshot);
            queryClient.setQueryData(queryKeys.ask.thread(id), context?.thread);
        },
        onSettled() {
            void queryClient.invalidateQueries({ queryKey: queryKeys.ask.threads() });
        },
    });
}
//# sourceMappingURL=use-rename-ask-thread.js.map